






















import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { parse } from 'qs'

@Component({
  components: {}
})
export default class PersonalPoint extends ViewBase {
  @Prop({ default: null }) process!: any
  lang: any = {}

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }

  created() {
    this.lang = this.i18n.vStudy
  }
}
